import React from "react";
import styled from "styled-components";
import ArrowLeftIcon from "../../assets/Icon/ArrowLeft/ArrowLeft";
import IconButton from "../../assets/Icon/IconButton/IconButton";
import Styleguide, { Colors, theme } from "../../theme";

const ButtonContainer = styled.div`
  position: absolute;
  left: 0;
  width: 30%;
`;

const DesktopBackButton = styled.button`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  font-family: ${Styleguide.fonts.heading.name};
  font-weight: ${Styleguide.fontWeights.semibold};
  font-size: 18px;
  color: ${theme(Colors.blue[100], Colors.gray[100])};

  :hover {
    color: ${theme(Colors.blue[200], Colors.gray[200])};
  }

  :active {
    color: ${theme(Colors.blue[300], Colors.gray[300])};
  }

  :focus-visible {
    border-radius: 8px;
    outline-width: 2px;
    outline-style: solid;
    outline-color: ${theme(Colors.blue[100], Colors.lightBlue[100])};
  }
`;

const HeaderMobile = styled.span`
  @media (min-width: ${Styleguide.breakpoints.wide}) {
    display: none;
  }
`;

const HeaderDesk = styled.span`
  display: none;
  @media (min-width: ${Styleguide.breakpoints.wide}) {
    display: block;
  }
`;

type BackButtonProps = {
  onBackClick: () => void;
};

export function ReturnButton({ onBackClick }: BackButtonProps) {
  return (
    <ButtonContainer>
      <HeaderMobile>
        <IconButton aria-label="Voltar" onClick={onBackClick}>
          <ArrowLeftIcon
            color={{ light: Colors.blue[100], dark: Colors.gray[100] }}
            size="xlarge"
          />
        </IconButton>
      </HeaderMobile>
      <HeaderDesk>
        <DesktopBackButton onClick={onBackClick}>
          <ArrowLeftIcon size="xlarge" />
          Voltar
        </DesktopBackButton>
      </HeaderDesk>
    </ButtonContainer>
  );
}
